import { Radio } from 'antd';
import './MethodPaymentRadio.scss';
import { cn } from '../../../utils/string/cn.utils';

const MethodPaymentRadio = ({ onChange, value, options, ...props }) => {
  return (
    <Radio.Group
      {...props}
      onChange={onChange}
      value={value}
      className={cn('method-payment-card flex flex-col', props.className)}
      options={options}
    />

    // <div {...props} className={"method-payment-card flex h-52 py-8 px-12 items-center gap-12 self-stretch rounded-[4px] bg-fills-white " + props.className}>
    //     {icon}
    //     <div className="flex flex-col justify-center items-start gap-2 grow">
    //         <span className="title-text-small">{label}</span>
    //         <span className="text-body-small">{description}</span>
    //     </div>
    // </div>
  );
};

export default MethodPaymentRadio;
